import React, { useState, useEffect, useContext } from "react";
import { Form, FormGroup, Label, Input, NavLink } from "reactstrap";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import { toast } from "react-toastify";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../components/global/Button";
import HoverTooltip from "../global/Tooltip";
import TopHeader from "./TopHeader";
import inprogress from "../../assets/images/in-progress.png";
import completed from "../../assets/images/completed.png";
import onhold from "../../assets/images/on-hold.png";
import open from "../../assets/images/open.png";
import uat from "../../assets/images/uat.png";
import handwave from "../../assets/images/wave.png";

const Home = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const { rolexModuleData, user_id, roles, userProfile, serialSequence, } = useContext(GlobalContext);
  const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const navigate = useNavigate();
  const currentDate = new Date()?.toISOString()?.substr(0, 10);

  const [taskCount, setTaskCount] = useState([]);
  const [startDate, setStartDate] = useState(
    new Date(new Date()?.getTime() - 7 * 24 * 60 * 60 * 1000)
      ?.toISOString()
      ?.substr(0, 10)
  );
  const [endDate, setEndDate] = useState(currentDate);
  const [userTimesheet, setUserTimesheet] = useState();
  const [loading, setLoading] = useState(true);

  const handleError = (error) => {
    const statusCode = error.response?.status || null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) errorMessage = "Internal Server Error!";
    else if (statusCode === 404) errorMessage = "Page Not Found!";

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };

  const getTaskCount = async (taskList) => {
    try {
      const response = await axios.get(
        `/getTaskCount?TaskList=${
          isSpecialAccess ? [] : taskList || [0]
        }`
      );
      setTaskCount(response?.data?.[0]);
    } catch (error) {
      handleError(error);
    }
  };

  const getUserData = async () => {
    try {
      const UserListCriteria =
      isSpecialAccess ? "" : userProfile || "";
      const response = await axios.get(
        `/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`
      );

      const userTaskList = response?.data?.[0]?.user_data
        ?.filter((item) => item?.user_id === user_id)?.[0]
        ?.user_x_task?.filter((data) => data?.task_access === 1)
        ?.map((data) => data?.task_id);

      await getTaskCount(userTaskList);
    } catch (error) {
      handleError(error);
    }
  };

  const getUserTimeSheet = async () => {
    try {
      const response = await axios.get("/getUserTimeSheet");
      setUserTimesheet(
        response?.data?.[0]?.user_timesheet?.filter((data2) =>
        isSpecialAccess
            ? data2
            : data2?.user_id === user_id
        )
      );
    } catch (error) {
      handleError(error);
    }
  };

  const [dateArray, setDateArray] = useState([]);
  const [uniqueMonths, setUniqueMonths] = useState([]);
  const renderDays = (StartDate, EndDate) => {
    const days = [];
    const startDate = new Date(StartDate);
    const endDate = new Date(EndDate);

    while (startDate <= endDate) {
      const dayOfWeek = ["S", "M", "T", "W", "Th", "F", "Sa"][
        startDate.getDay()
      ];
      days.push({ date: new Date(startDate), dayOfWeek });
      startDate.setDate(startDate.getDate() + 1);
    }

    const months = Array.from(
      new Set(days.map((item) => item.date.toLocaleString("default", { month: "long", year: "numeric" })))
    );

    setDateArray(days);
    setUniqueMonths(months);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await getUserData();
        await getUserTimeSheet();
        renderDays(startDate, endDate);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getTaskClassName = (data, day) => {
    const tasksForDay = data?.tasks_timesheet?.filter(
      (task) => task?.Date === day?.date?.toISOString()?.split("T")?.[0]
    );

    if (tasksForDay?.length > 0) return "completed";

    if (currentDate > day?.date?.toISOString()?.split("T")?.[0]) {
      const minStartDate = data?.tasks_timesheet?.reduce((min, task) => {
        const startDate = new Date(task?.task_master?.[0]?.task_start_date);
        return startDate < min ? startDate : min;
      }, new Date("9999-12-31"));

      const maxEndDate = data?.tasks_timesheet?.reduce((max, task) => {
        const endDate = new Date(task?.task_master?.[0]?.task_end_date);
        return endDate > max ? endDate : max;
      }, new Date("0000-01-01"));

      if (minStartDate > new Date(day?.date?.toISOString()?.split("T")?.[0]))
        return "archiveDates";

      if (maxEndDate >= new Date(day?.date?.toISOString()?.split("T")?.[0]))
        return "pending";
    }
  };

  const calculateTotalDuration = (data, day) => {
    const tasksForDay = data?.tasks_timesheet?.filter(
      (obj) => obj?.Date === day?.date?.toISOString()?.split("T")?.[0]
    );

    const totalDuration = tasksForDay?.reduce((total, obj) => {
      const duration =
        obj?.Duration != null && obj?.Duration !== ""
          ? Number(obj?.Duration)
          : (new Date(`1970-01-01T${obj?.end_time}`)?.getTime() -
              new Date(`1970-01-01T${obj?.start_time}`)?.getTime()) /
            1000 /
            60 /
            60;

      return duration > 0 ? total + duration : total;
    }, 0);

    return totalDuration > 0 ? totalDuration?.toFixed(2) : "";
  };

  const calculateDuration = (task) => {
    if (task && task?.Duration != null && task?.Duration !== "") {
      const duration = Number(task?.Duration);
      return duration > 0 ? duration?.toFixed(2) : "";
    } else {
      const startTime = new Date(`1970-01-01T${task?.start_time}`)?.getTime();
      const endTime = new Date(`1970-01-01T${task?.end_time}`)?.getTime();
      const durationInHours = (endTime - startTime) / (1000 * 60 * 60);
      return durationInHours > 0 ? durationInHours?.toFixed(2) : "";
    }
  };

  const getTooltipContent = (data, day) => {
    const tasksForDay = data?.tasks_timesheet?.filter(
      (obj) => obj?.Date === day?.date?.toISOString()?.split("T")?.[0]
    );

    return tasksForDay?.map((obj) => (
      <div key={obj?.id}>
        {`${obj?.task_master?.[0]?.task_title} (${calculateDuration(obj)} hrs)`}
      </div>
    ));
  };

  return loading ? (
    <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
  )  : (
    <>
       <TopHeader
        breadCrumb={
          <li className="nav-item">
            <span>Home</span>
          </li>
        }
      />
        <div id="homepage" className="contentInnerWrap">
        {userProfile?.firstLoginStatus === "1" && (
          <h3 className="text-center">
            <span>
              <img className="welcomeUser wave" src={handwave} alt="Handwave" />
            </span>
            Hi,{" "}
            <span style={{ color: "#e55353" }}>
              {userProfile.name?.split(" ")?.[0]}
            </span>
          </h3>
        )}
      <div className="homepagewrap">
          <div className="dashboardSummary" style={{ clear: "both" }}>
            <h5>Task Status</h5>
            <div className="dashboard-summary-container">
              <a className="dashboard-summary-tile" onClick={() => navigate(`/task?status=${btoa("Pipeline")}`)} >
                <div className="dashboard-summary-value dashOpen">
                  <div className="dashicon">
                    <img src={open} alt="Open Icon" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                        {taskCount?.PipelinetaskCount || '0'}
                    </div>
                    <div className="title">Open</div>
                  </div>
                </div>
              </a>
              <a className="dashboard-summary-tile" onClick={() => navigate(`/task?status=${btoa("In Progress")}`)} >
                <div className="dashboard-summary-value dashInProgress">
                  <div className="dashicon">
                    <img src={inprogress} alt="In Progress Icon" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                               {taskCount?.InProgresstaskCount || '0'}
                    </div>
                    <div className="title">In Progress</div>
                  </div>
                </div>
              </a>
              <a className="dashboard-summary-tile" onClick={() => navigate(`/task?status=${btoa("On Hold")}`)} >
                <div className="dashboard-summary-value dashOnHold">
                  <div className="dashicon">
                    <img src={onhold} alt="On Hold Icon" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                          {taskCount?.OnHoldtaskCount || '0'}
                    </div>
                    <div className="title">On Hold</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("UAT")}`)}
              >
                <div className="dashboard-summary-value dashUAT">
                  <div className="dashicon">
                    <img src={uat} alt="UAT Icon" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                        {taskCount?.UATtaskCount || '0'}
                    </div>
                    <div className="title">UAT</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("Completed")}`)}
              >
                <div className="dashboard-summary-value dashMilestone">
                  <div className="dashicon">
                    <img src={completed} alt="Completed Icon" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                       {taskCount?.CompletedtaskCount || '0'}
                    </div>
                    <div className="title">Completed</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="userProjectSnapshot" style={{ clear: "both" }}>         
            <div className="sec-heading">
              <h5 className="ps-0 px-0">User Tasks</h5>     
            </div>
            <div className="colorRepresent">
              <ul>
                <li>
                <span className="colors active"></span>Done
                </li>
                <li>
                <span className=" colors inprogress"></span>Missing
                </li>
              
              </ul>
            </div>
            <div className="filterOptions">
              <Form className="modelform">
                <FormGroup className="filterFields">
                  <Label htmlFor="projectTitle">Start Date*</Label>
                  <Input
                    type="date"
                    id="startDate"
                    name="startDate"
                    min={new Date(
                      Date?.now() -
                        serialSequence?.[5]?.project_seqence *
                          24 *
                          60 *
                          60 *
                          1000
                    )
                      ?.toISOString()
                      ?.slice(0, 10)}
                    max={endDate}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </FormGroup>
                <FormGroup className="filterFields">
                  <Label htmlFor="projectTitle">End Date*</Label>
                  <Input
                    type="date"
                    id="endDate"
                    name="endDate"
                    min={startDate}
                    max={currentDate}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </FormGroup>
                <div className="actBtn">
                  <Button
                    type="button"
                    className="m-0"
                    name="apply"
                    id="apply"
                    onClick={() => renderDays(startDate, endDate)}
                  >
                    Apply
                  </Button>
                </div>
              </Form>
            </div>
            <div className="snapshotHeader gantt-chart">
              <MDBTable align="middle">
                <MDBTableHead style={{ position: "sticky", top: "0" }}>
                  <tr>
                    <th
                      key="userColumn"
                      rowSpan="2"
                      style={{
                        width: "420px",
                        fontSize: "1.125rem",
                        fontWeight: "normal",
                        textAlign: "left",
                        verticalAlign: "middle",
                        position: "sticky",
                        left: "0",
                        zIndex: "2",
                        borderRight: "1px solid #fff",
                      }}
                    >
                      {isSpecialAccess
                        ? "Users"
                        : "Name"}
                    </th>
                    {uniqueMonths?.map((data, index) => (
                      <th
                        key={`monthColumn-${index}`}
                        colSpan={
                          dateArray?.filter(
                            (item) =>
                              item?.date?.toLocaleString("default", {
                                month: "long",
                                year: "numeric",
                              }) === data
                          )?.length
                        }
                      >
                        {data}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {dateArray?.map((day, index1) => (
                      <th key={`dayColumn-${index1}`}>
                        <span style={{ display: "block" }}>
                          {day?.date?.getDate()}
                        </span>
                        <span style={{ display: "block" }}>
                          {day?.dayOfWeek}
                        </span>{" "}
                      </th>
                    ))}
                  </tr>
                </MDBTableHead>

                <MDBTableBody>
                  {userTimesheet?.length > 0 ? (
                    userTimesheet?.map((data, index) => (
                      <tr
                        key={`userTimesheet-${index}`}
                        className="table-light"
                      >
                        <th
                          className="table-header"
                          style={{
                            width: "420px",
                            display: "inline-block",
                            textAlign: "left",
                            minHeight: "45px",
                            background: "#fff",
                            fontSize: "14px",
                            color: "#4061ad",
                            fontWeight: "normal",
                            position: "sticky",
                            left: "0",
                            zIndex: "2",
                          }}
                        >
                          {`${data?.name} (${data?.username})`}
                        </th>
                        {dateArray?.map((day, index1) => (
                          <td
                            className={getTaskClassName(data, day)}
                            colSpan="1"
                            key={`timesheet-${index}-${index1}`}
                          >
                            <HoverTooltip
                              arrow
                              title={
                                getTooltipContent(data, day) || "Default Date"
                              }
                            >
                              <NavLink>
                                {calculateTotalDuration(data, day)}
                              </NavLink>
                            </HoverTooltip>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr key="noData">
                      <th>There is no data available!</th>
                    </tr>
                  )}
                </MDBTableBody>
              </MDBTable>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
